import React from 'react';

export const AppUserContext = React.createContext({});
export const AppParamsContext = React.createContext({});
